import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getbranchforclinicSlice = createAsyncThunk(
    "branch/getBranchForClinic",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/branch/getBranchForClinic",
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: data.token
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getAllBranchByClinic = createAsyncThunk(
    "branch/getAllBranchByClinic",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/branch/getAllBranchByClinic", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const handleBranchRequestSlice = createAsyncThunk(
    "branch/handleBranchRequest",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/branch/handleBranchRequest", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getParentData = createAsyncThunk(
    "branch/getParentData",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/branch/getParentData",
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: data.token
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getParentChildData = createAsyncThunk(
    "branch/getParentAndChildClinic",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/branch/getParentAndChildClinic", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const initialState = {
    loading: false,
    branches: [],
    branchByclinic: [],
    data: [],
    ParentAndChildData: [],
    branchSuccessMessage: null,
    branchErrorMessage: null,
    searchBranchErrorMessage: null,
    currentPage: 1,
    totalPages: null,
    hasMore: true,
    totalCount: 0,
};

const branchSlice = createSlice({
    name: "branch",
    initialState,
    reducers: {
        resetBranchMessage: (state) => {
            state.branchSuccessMessage = null;
            state.searchBranchErrorMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getbranchforclinicSlice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getbranchforclinicSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload.result.list;
            })
            .addCase(getbranchforclinicSlice.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(handleBranchRequestSlice.pending, (state) => {
                state.loading = true;
                state.branchSuccessMessage = null;
                state.branchErrorMessage = null;
            })
            .addCase(handleBranchRequestSlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.branchErrorMessage = action.payload.result.message;
                } else {
                    state.branchSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(handleBranchRequestSlice.rejected, (state, action) => {
                state.loading = false;
                state.branchErrorMessage = action.payload.message;
            })
            .addCase(getAllBranchByClinic.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllBranchByClinic.fulfilled, (state, action) => {
                state.loading = false;
                if (!action.payload.success) {
                    state.branchByclinic = [];
                    state.totalCount = 0;
                    state.totalPages = 1;
                    state.searchBranchErrorMessage =
                        action.payload.result?.message || "No data found";
                    return;
                }
                const result = action.payload.result;
                state.branchByclinic = result.list || [];
                state.currentPage = Number(result.currentPage) || 1;
                state.totalPages = Number(result.totalPages) || 1;
                state.totalCount = Number(result.totalRecords) || 0;
                state.hasMore = result.hasMore ?? false;
                state.searchBranchErrorMessage = null;
            })
            .addCase(getAllBranchByClinic.rejected, (state, action) => {
                state.loading = false;
                state.searchBranchErrorMessage = action.payload.message;
            })
            .addCase(getParentData.pending, (state) => {
                state.loading = true;
                state.branchSuccessMessage = null;
                state.branchErrorMessage = null;
            })
            .addCase(getParentData.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.branchErrorMessage = action.payload.result.message;
                } else {
                    state.data = action.payload.result;
                }
            })
            .addCase(getParentData.rejected, (state, action) => {
                state.loading = false;
                state.branchErrorMessage = action.payload;
            })
            .addCase(getParentChildData.pending, (state) => {
                state.loading = true;
                state.branchSuccessMessage = null;
                state.branchErrorMessage = null;
            })
            .addCase(getParentChildData.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.branchErrorMessage = action.payload.result.message;
                } else {
                    state.ParentAndChildData = action.payload.result.list;
                }
            })
            .addCase(getParentChildData.rejected, (state, action) => {
                state.loading = false;
                state.branchErrorMessage = action.payload;
            });

    },
});

export const {
    resetBranchMessage,
} = branchSlice.actions;
export default branchSlice.reducer;
